
import {filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Subject } from 'rxjs';
import { Router, NavigationError } from "@angular/router";
import { EmitterService } from '../services/emitter.service';

@Injectable()
export class AppDetailsService {

  appAvailableCountries;
  appAvailableCurrencies;
  gameLauncherDetails;
  presentcountry;
  minlimit;
  routerEvent;
  blockCountryResponseStack = [];
  blockedCountryResponse;
  private currency = new Subject<string>();
  currency$ = this.currency.asObservable();

  constructor(
    private ajaxService:AjaxService,
    private router: Router,
    private emitterService : EmitterService
  ) { }

  setAvailableCountries(countries){
    this.appAvailableCountries = countries;
  }

  getAvailableCountries(){
    return this.appAvailableCountries;
  }

  setAvailableCurrencies(currencies){
    this.appAvailableCurrencies = currencies;
    this.currency.next(this.appAvailableCurrencies);
  }

  getAvailableCurrencies(){
    return this.appAvailableCurrencies;
  }

  setGameLauncherParams(gameId, gameLaunchUrlPath){
    this.gameLauncherDetails = {
      "gameId": gameId,
      "gameLaunchUrlPath": gameLaunchUrlPath
    };
  }

  getGameLauncherParams(){
    return this.gameLauncherDetails;
  }

  deleteGameLauncherParams(){
    this.gameLauncherDetails = undefined;
  }

  set country(country: String){
    this.presentcountry= country;
  }
  get country(){
    return this.presentcountry;
  }
  set limit(limit: String){
    this.minlimit = limit;
  }
  get limit(){
    return this.minlimit;
  }
  getBlockedCountryResponse(){
    return this.blockedCountryResponse;
  }

  getBlockedCountries(){
    if(this.blockedCountryResponse) return this.blockedCountryResponse;

    return new Promise((resolve, reject) => {
    if(this.blockCountryResponseStack.length > 0){
      this.blockCountryResponseStack.push(resolve);
    }else{
      this.blockCountryResponseStack.push(resolve);
     Promise.resolve(this.ajaxService.isBlockedCountry())
      .then(res => {
        this.blockedCountryResponse = res;
        this.emitterService.broadCastJurisdictionValue(res?.jurisdiction);
        this.emitterService.broadCastPrevJurisdictionValue(res?.jurisdiction);
        for (let callback in  this.blockCountryResponseStack){
          if (callback){
            this.blockCountryResponseStack[callback](this.blockedCountryResponse);
          }
        }
        this.blockCountryResponseStack = [];
       // return this.blockedCountryResponse;
      },
        SystemError => { }
      );
    }
  });
  }
  getToRedirectionURL(){
    if(localStorage.getItem("redirectStep")){
      this.router.navigate([localStorage.getItem('langCode') + "/" + localStorage.getItem("redirectStep")]);
      this.redirectiondecider(localStorage.getItem("redirectStep"));
      localStorage.removeItem("redirectStep");
    }
  }

  redirectiondecider(url: string) {
    this.routerEvent = this.router.events.pipe(filter(event => event instanceof NavigationError)).subscribe((e) => {
       if (e["error"]["message"].includes(url)) {
        this.emitterService.broadcastAllGamesEmitter(url);
       }else{

       }
    });
  }

  loadHomepage(langcode) {
    this.router.navigate([langcode]);
    // setTimeout(() => {
    //   window.location.reload();
    // });
  }
}
